import React from 'react';
import { useGlobalContext } from '@/context/GlobalContext';

const TabularComponent = ({ data }: any) => {
  const { setLeadFormData, setIsLeadFormOpen } = useGlobalContext();

  const handleOpen = (course: any) => {
    const courseData: any = [
      {
        id: course?.id,
        abbreviation: course?.abbreviation,
        course_name: course?.course_name,
      },
    ];
    console.log('course', courseData);
    setLeadFormData({
      source: `courseLandingPage`,
      course: courseData || null,
      title: course?.course_name || null,
    });
    setIsLeadFormOpen(true);
  };

  const tableHeaders = [
    { key: 'course', label: 'Course' },
    { key: 'fees', label: 'Fees' },
    { key: 'eligibility', label: 'Eligibility' },
    { key: 'duration', label: 'Duration' },
    { key: 'applicationDate', label: 'Application Date' },
    { key: 'action', label: 'Action' },
  ];

  return (
    <div className="max-w-full overflow-x-scroll">
      <table className="min-w-[1000px] border-collapse border border-gray-300">
        <thead>
          <tr>
            {tableHeaders.map((header) => (
              <th key={header.key} className="whitespace-nowrap border border-gray-300 px-4 py-2">
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row: any) => (
            <tr key={row?.id} className="hover:bg-gray-100">
              <td className="whitespace-normal break-words border border-gray-300 px-4 py-2 text-center">
                {row.course_name?.course_name}
              </td>
              <td className="break-words border border-gray-300 px-4 py-2 text-center text-teal-600">
                {row.course_fee}
              </td>
              <td className="whitespace-normal break-words border border-gray-300 px-4 py-2 text-center">
                {row.eligibility}
              </td>
              <td className="whitespace-normal break-words border border-gray-300 px-4 py-2 text-center">
                {row.course_duration?.duration}
              </td>
              <td className="whitespace-normal break-words border border-gray-300 px-4 py-2 text-center">
                {row.application_date}
              </td>
              <td className="whitespace-normal break-words border border-gray-300 px-4 py-2 text-center">
                <button
                  className="rounded px-3 py-1 font-semibold text-primary"
                  onClick={() => handleOpen(row.course_name)}
                >
                  Apply &rarr;
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TabularComponent;
